import { render } from "./question-7.vue?vue&type=template&id=69e8d987&ts=true"
import script from "./question-7.vue?vue&type=script&lang=ts"
export * from "./question-7.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__